<div class="desktop">
    <div class="label">
        {{label}}
    </div>
    <div class="value">
        <ap-money [readonly]="readonly" [inDollars]="false" [(amount)]="inputValue" matInput (amountChange)="saveAmount()" aria-label="field-text"></ap-money>
    </div>
</div>
